export const typeDefs = `
  union TopUpSortType = date | amount | trxId

  input TopUpFilterInput {
    date: [String]
    amount: [Float]
    trxId: String
  }
`;
